import { useEffect, useState } from 'react';
import { useApi } from '@backstage/frontend-plugin-api';
import { policyApiRef } from '@internal/plugin-policy';

/**
 * Tenants the signed-in user administers, as the orchestrator answers
 * `authorization/me` for each (every authorized tenant for a platform admin).
 * Empty while loading or on failure, so an admin-only entry never flashes in.
 * Re-checked every 30 seconds while the tab is visible, so a granted or
 * revoked role reaches the sidebar without a reload.
 */
export function useAdministrationTenants(): string[] {
  const api = useApi(policyApiRef);
  const [tenants, setTenants] = useState<string[]>([]);

  useEffect(() => {
    let request: AbortController | undefined;
    const check = () => {
      request?.abort();
      request = new AbortController();
      const current = request;
      api.listAdministrationTenants(current.signal).then(
        access => {
          if (!current.signal.aborted) setTenants(access.tenants);
        },
        () => {
          if (!current.signal.aborted) setTenants([]);
        },
      );
    };
    check();
    const timer = window.setInterval(() => {
      if (document.visibilityState === 'visible') check();
    }, 30_000);
    return () => {
      window.clearInterval(timer);
      request?.abort();
    };
  }, [api]);

  return tenants;
}
